/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from "react";
import Navbar from "../components/Navbar";

const MFHome = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Navbar />

      <main className="pt-20">

        {/* HERO */}
        <section className="px-8 md:px-20 py-20 bg-gray-100">
          <div className="max-w-screen-2xl mx-auto grid md:grid-cols-2 gap-10 items-center">

            <div>
              <h1 className="text-5xl font-bold mb-6">
                Invest Smarter in Mutual Funds
              </h1>

              <p className="text-gray-600 mb-8">
                Direct access to AMCs with powerful analytics insights
              </p>

              <div className="flex gap-4">
                <button className="bg-green-600 text-white px-6 py-3 rounded-full">
                  Start Investing
                </button>

                <button className="border px-6 py-3 rounded-full">
                  Explore Funds
                </button>
              </div>
            </div>

            <div className="h-[300px] bg-gray-200 rounded-xl flex items-center justify-center">
              Hero Image
            </div>
          </div>
        </section>

        {/* ANALYTICS SECTION */}
        <section className="px-8 md:px-20 py-20">
          <h2 className="text-3xl font-bold mb-10">
            Orion Analytics Engine
          </h2>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="p-6 bg-white rounded-xl shadow">
              <h3 className="font-bold">Sharpe Ratio</h3>
              <p className="text-2xl mt-2">1.82</p>
            </div>

            <div className="p-6 bg-white rounded-xl shadow">
              <h3 className="font-bold">Alpha</h3>
              <p className="text-2xl mt-2">+4.2%</p>
            </div>

            <div className="p-6 bg-white rounded-xl shadow">
              <h3 className="font-bold">Volatility</h3>
              <p className="text-2xl mt-2">Moderate</p>
            </div>
          </div>
        </section>

        {/* CALCULATOR */}
        <section className="px-8 md:px-20 py-20 bg-gray-100">
          <h2 className="text-3xl font-bold mb-10">
            SIP Calculator
          </h2>

          <div className="bg-white p-8 rounded-xl shadow max-w-xl">
            <label>Monthly Investment</label>
            <input
              type="range"
              className="w-full mt-2 mb-4"
            />

            <label>Expected Return</label>
            <input
              type="range"
              className="w-full mt-2 mb-4"
            />

            <label>Years</label>
            <input
              type="range"
              className="w-full mt-2 mb-4"
            />

            <div className="mt-6 p-4 bg-green-600 text-white rounded-xl">
              Estimated Wealth: ₹1.2 Cr
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default MFHome;